import React from 'react'
import { useAppContext } from '../context/AppContext';
import Header from '../components/Header';
// import ProfileMenu from '../components/profileMenu';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/system';
import FacilitiesSidebar from '../sidebar/FacilitiesSidebar';

export default function FacilitiesLayout(props) {
    const {
        isMobile,
        drawerOpen,
    } = useAppContext();

    return (
        <React.Fragment>
            <Header/>
            {/* <ProfileMenu /> */}
            <FacilitiesSidebar />
            <div
                style={{
                    // minHeight: isMobile ? "calc(100vh - 40px)" : "100vh",
                    minHeight: "calc(100vh - 80px)",
                    backgroundColor: "#FAFAF9",
                    // backgroundImage: `url(${background})`,
                    // backgroundSize: "cover",
                    // backgroundPosition: isMobile ? "center -250px" : "center",
                    // backgroundRepeat: "no-repeat",
                    marginLeft: isMobile ? "0px" : !drawerOpen ? "280px" : "0px",
                    marginTop: "55px",
                }}
            >
                {props.children}

                {/* Page content here */}
                <Box sx={{
                    paddingX: isMobile ? "10px" : "20px",
                    paddingY: "20px",
                }}>
                    <Outlet />
                </Box>
            </div>
        </React.Fragment>
    )
}
